import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import './App.css';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import LandingPage from './pages/LandingVanguard';
import Propuesta from './pages/Propuesta';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Publicaciones from './pages/Publicaciones';
import NuevaPublicacion from './pages/NuevaPublicacion';
import DetallePublicacion from './pages/DetallePublicacion';
import Ofertas from './pages/Ofertas';
import Revendedores from './pages/Revendedores';
import Usuarios from './pages/Usuarios';
import Reportes from './pages/Reportes';
import Sucursales from './pages/Sucursales';
import Mensajes from './pages/Mensajes';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ThemeProvider>
          <AuthProvider>
            <Routes>
              {/* Landing page pública */}
              <Route path="/" element={<LandingPage />} />
              
              {/* Propuesta comercial */}
              <Route path="/propuesta" element={<Propuesta />} />
              
              {/* Sistema de gestión protegido */}
              <Route path="/login" element={<Login />} />
              <Route path="/admin" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
                <Route index element={<Dashboard />} />
                <Route path="publicaciones" element={<Publicaciones />} />
                <Route path="publicaciones/nueva" element={<NuevaPublicacion />} />
                <Route path="publicaciones/:id" element={<DetallePublicacion />} />
                <Route path="ofertas" element={<Ofertas />} />
                <Route path="revendedores" element={<Revendedores />} />
                <Route path="usuarios" element={<Usuarios />} />
                <Route path="sucursales" element={<Sucursales />} />
                <Route path="mensajes" element={<Mensajes />} />
                <Route path="reportes" element={<Reportes />} />
              </Route>
            </Routes>
          </AuthProvider>
        </ThemeProvider>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;